import axios from 'axios';

export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API, headers: { 'X-Public-Base': window.location.origin } });
api.interceptors.request.use((cfg) => {
  const t = localStorage.getItem('kyc_token');
  if (t) cfg.headers.Authorization = `Bearer ${t}`;
  return cfg;
});

export const errorMessage = (e) => {
  const d = e?.response?.data?.detail ?? e?.response?.data;
  if (!d) return e?.message || 'Request failed';
  if (typeof d === 'string') return d;
  if (d.conflicts) return `Conflicts: ${d.conflicts.join('; ')}`;
  if (d.message) return d.message;
  if (d.errors) return Object.values(d.errors).join(' ');
  if (d.error) return String(d.error);
  return JSON.stringify(d);
};

// Public (token-scoped) client
export const publicApi = (token, verifyToken) => {
  const inst = axios.create({ baseURL: `${API}/public/requests/${token}` });
  if (verifyToken) inst.defaults.headers['X-Verify-Token'] = verifyToken;
  return inst;
};
